import apiHandler from "../core/apiHandler";
const branchApi = apiHandler('branches');
export default branchApi;
